import { render, staticRenderFns } from "./resetpassword.vue?vue&type=template&id=45872c6c&scoped=true&"
import script from "./resetpassword.vue?vue&type=script&lang=js&"
export * from "./resetpassword.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/login.css?vue&type=style&index=0&id=45872c6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45872c6c",
  null
  
)

export default component.exports